import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-stone-900 text-stone-200" data-id="element-95" data-mp="3geze367ujv27">
      <div className="h-2 w-full bg-amber-500" aria-hidden="true" data-id="element-96" data-mp="3ggk72reij5xy" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-97" data-mp="32onl753ftsa0">
        <p className="font-serif text-lg font-extrabold uppercase tracking-tight text-amber-400" data-id="element-98" data-mp="36pfutzg81z6t">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-99" data-mp="3ueik9th3kwbv">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-stone-700 pt-6 text-xs" data-id="element-100" data-mp="38h7nghhhuo4">
          © 2026 Megapack Petróleo y Gas Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}